var map = {
	"./1/screen-1.jpg": 782,
	"./1/screen-2.jpg": 3846,
	"./1/screen-3.jpg": 2712,
	"./1/screen-4.jpg": 2052,
	"./1/screen-5.jpg": 8452,
	"./1/screen-6.jpg": 2677,
	"./2/screen-1.jpg": 1350,
	"./2/screen-2.jpg": 1840,
	"./3/screen-1.jpg": 4532,
	"./3/screen-2.jpg": 4706,
	"./3/screen-3.jpg": 9654,
	"./4/screen-1.jpg": 4084,
	"./4/screen-2.jpg": 2204,
	"./4/screen-3.jpg": 7784,
	"./5/screen-1.jpg": 3157,
	"./5/screen-2.jpg": 5364,
	"./5/screen-3.jpg": 8201,
	"./5/screen-4.jpg": 1715,
	"./6/screen-1.jpg": 5956,
	"./6/screen-2.jpg": 6178,
	"./6/screen-3.jpg": 2115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9696;